/**
 * Switches that differ between the dev tier and production.
 *
 * `NEXT_PUBLIC_*` is inlined at build time, so each tier's own `frontend/.env`
 * decides (dev.grittranslate.com runs `next dev` on dev/frontend/.env; the
 * production build reads prod/frontend/.env). Anything not set is OFF, so a
 * feature only appears where a tier asked for it.
 */

/**
 * Camps in the navbar: the Camps tab, its row in the section switcher, "Your
 * Camps" in the account menu, and Camps results in the nav search. Camps pages
 * themselves still work by link (a game's official post, a shared post).
 * Dev sets NEXT_PUBLIC_CAMPS_IN_NAV=1; production leaves it unset.
 */
export const CAMPS_IN_NAV = process.env.NEXT_PUBLIC_CAMPS_IN_NAV === '1';

/**
 * The Developer Platform's build side: making a game, uploading, publishing,
 * CLI tokens and posting a made game in a Camp. Closed for now (owner,
 * 2026-10-15: it needs internal infrastructure first; "do not remove the
 * items, simply disable them"). The buttons stay, greyed with "Coming soon";
 * the docs, the gallery and playing stay open. Console staff can still build,
 * to test. The server enforces the same rule (backend lib/devApps.ts
 * DEV_PLATFORM_OPEN): flip both to open it.
 */
export const DEV_PLATFORM_OPEN = false;
